module.exports = __webpack_public_path__ + "assets/events-black.aa491dc8.svg";